module.exports = __webpack_public_path__ + "static/bootstrap-modal-41ea68ee466ea70d03af0a7966e26e80.png";